<template>
  <div class="noWrap">
    {{ getType }}
  </div>
</template>

<script>
export default {
  name: 'HolidayTypeColumn',
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    typeOptions: [
      {
        value: 'Federal',
        text: 'Federal',
      },
      {
        value: 'State',
        text: 'Estadual',
      },
      {
        value: 'Local',
        text: 'Local',
      },
    ],
  }),
  computed: {
    getType() {
      const findType = this.typeOptions.find(
        (type) => type.value === this.value,
      );

      return findType ? findType.text : this.value;
    },
  },
};
</script>

<style>

</style>
